// extracted by mini-css-extract-plugin
export default {"viewActions":"GroceryQualityCheck_viewActions__4VOT8"};